// DEPRECATED
// Please don't use this, use jsonfetchservice.js (or window.fetch directly) instead (https://developer.mozilla.org/en/docs/Web/API/Fetch_API)

import {
    getToken,
    requestShouldIncludeToken,
} from '../services/csrfTokenService.js';

const csrfToken = getToken();

function addCsrfToken({ headers, method = 'GET' }) {
    if (csrfToken && requestShouldIncludeToken(method)) {
        return Object.assign({}, headers, {
            'x-csrf-token': csrfToken,
        });
    }

    return headers;
}

export default {
    name: 'xhrservice',
    dependencies: ['reqwest'],
    callable(reqwest) {
        function request(opts) {
            return new Promise((resolve, reject) => {
                const requestOpts = {
                    url: opts.url,
                    method: opts.method,
                    type: opts.type,
                    contentType: opts.contentType,
                    withCredentials: opts.withCredentials,
                    crossOrigin: true, // Set to true to avoid reqwest setting X-Requested-With: XMLHttpRequest
                    data: opts.data,
                    headers: addCsrfToken({
                        headers: opts.headers,
                        method: opts.method,
                    }),
                    jsonpCallback: opts.jsonpCallback,
                    timeout: opts.timeout,
                    success: resolve,
                    error: reject,
                };
                const req = reqwest(requestOpts);
                if (opts.canceler) {
                    opts.canceler.then(() => {
                        // reqwest's abort rejects the promise, which is not very useful since
                        // we can't differentiate between aborted requests and other errors, e.g.
                        // timeouts or 500. Resolve it first before aborting.
                        resolve();
                        req.abort();
                    });
                }
            });
        }

        function getJson(url) {
            return request({
                url,
                type: 'json',
            });
        }

        function canceler() {
            let resolver;
            const promise = new Promise(resolve => {
                resolver = resolve;
            });

            resolver.then = promise.then.bind(promise);
            return resolver;
        }

        return {
            request,
            getJson,
            canceler,
        };
    },
};



// WEBPACK FOOTER //
// ./services/xhrservice.js